import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { fetchPositions } from '@/lib/polymarketApi'
import type { PositionInfo } from '@/lib/rangeMarketUtils'

/**
 * Data API: current positions for an address, keyed by asset (token id).
 */
export function usePositions(address: string | null | undefined): Map<string, PositionInfo> {
  const enabled = Boolean(address && typeof address === 'string' && address.startsWith('0x'))
  const { data: list } = useQuery({
    queryKey: ['positions', address ?? ''],
    queryFn: () => fetchPositions(address!),
    enabled,
    staleTime: 5_000,
    refetchInterval: 5_000,
  })
  return useMemo(() => {
    const map = new Map<string, PositionInfo>()
    if (!list?.length) return map
    for (const p of list) {
      if (p.asset) map.set(p.asset, { size: p.size, avgPrice: p.avgPrice })
    }
    return map
  }, [list])
}
